import { Token } from '../utils/types';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: Token = {
  token: '',
  refreshToken: '',
};

export const tokenSlice = createSlice({
  name: 'tokenSlice',
  initialState,
  reducers: {
    updateToken: (state, action: PayloadAction<Token>) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    deleteToken: (state) => {
      localStorage.removeItem('authToken');
      state.token = initialState.token;
      state.refreshToken = initialState.refreshToken;
    },
  },
});

export const { updateToken, deleteToken } =
  tokenSlice.actions;

export default tokenSlice.reducer;
